import { DeleteRequest } from "../../services/ApiClientService"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useGetCategory } from "./useGetCategory"
import { CategoryEntity } from "../../Objects/Category/CategoryEntity"
import { useTranslation } from "react-i18next"

export const useRemoveCategory = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const { handleGetCategory } = useGetCategory()

  const handleRemove = async (category: CategoryEntity, onSuccess: any) => {
    try {
      enableLoad()

      var response = await DeleteRequest(`${API_ROUTES.CATEGORY.DELETE}/${category.id}`)

      if (response.success) {
        await handleGetCategory(onSuccess)

        return
      }

      throw new Error(response.message)
    } catch (e: any) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return {
    handleRemove,
  }
}
